// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let React = require("react");
let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let FeaturesV3 = require("../../../reason/featureFlipper/FeaturesV3.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let TogglesGroup = require("../../../uikit/reason/molecules/TogglesGroup/TogglesGroup.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let RadioButtonNew = require("../../../uikit/reason/atoms/Form/RadioButtonNew.bs.js");
let SearchPagesUtils = require("../../common/SearchPagesUtils.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyFilterOptions = require("../../common/Form/PropertyFilterOptions.bs.js");
let PropertiesPageRelayQueryParams = require("./PropertiesPageRelayQueryParams.bs.js");
let PropertiesFiltersAreasAutocomplete = require("./PropertiesFiltersAreasAutocomplete.bs.js");

function PropertiesPageRelayFilters$PropertyTypes(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let isDesktop = MediaQuery.isDesktop();
  let mobileMenu = !isDesktop;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Property Types"
      }),
      JsxRuntime.jsx(TogglesGroup.make, {
        inline: !mobileMenu,
        children: props.rentalMode ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.rentalPropertyTypes = SearchPagesUtils.toggleIncluded(params.rentalPropertyTypes, "SINGLE_FAMILY");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.rentalPropertyTypes, "SINGLE_FAMILY"),
                label: "Single-family",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.rentalPropertyTypes = SearchPagesUtils.toggleIncluded(params.rentalPropertyTypes, "CONDO");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.rentalPropertyTypes, "CONDO"),
                label: "Condo/townhouse",
                mobileStyles: mobileMenu
              })
            ]
          }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.forSalePropertyTypes = SearchPagesUtils.toggleIncluded(params.forSalePropertyTypes, "SINGLE_FAMILY");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.forSalePropertyTypes, "SINGLE_FAMILY"),
                label: "Single-family",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.forSalePropertyTypes = SearchPagesUtils.toggleIncluded(params.forSalePropertyTypes, "MULTI_UNIT");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.forSalePropertyTypes, "MULTI_UNIT"),
                label: "Multi-unit",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.forSalePropertyTypes = SearchPagesUtils.toggleIncluded(params.forSalePropertyTypes, "CONDO");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.forSalePropertyTypes, "CONDO"),
                label: "Condo/townhouse",
                mobileStyles: mobileMenu
              }),
              JsxRuntime.jsx(Form__Checkbox.make, {
                onChange: param => refetch(undefined, undefined, undefined, params => {
                  let newrecord = {...params};
                  newrecord.forSalePropertyTypes = SearchPagesUtils.toggleIncluded(params.forSalePropertyTypes, "LOT");
                  return newrecord;
                }),
                checked: SearchPagesUtils.optIncludes(params.forSalePropertyTypes, "LOT"),
                label: "Lot",
                mobileStyles: mobileMenu
              })
            ]
          })
      })
    ]
  });
}

let PropertyTypes = {
  Checkbox: undefined,
  TogglesGroup: undefined,
  make: PropertiesPageRelayFilters$PropertyTypes
};

let options = [
  [
    "RECENTLY_BROADCAST",
    "Recently broadcast"
  ],
  [
    "RECENTLY_UPDATED",
    "Recently updated"
  ]
];

function labelFor(sortOrder) {
  return Stdlib_Option.getOr(Stdlib_Array.findMap(options, param => {
    if (param[0] === sortOrder) {
      return param[1];
    }
  }), "Recently broadcast");
}

function PropertiesPageRelayFilters$SortOrder(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Sort by"
      }),
      JsxRuntime.jsx(RadioButtonNew.RadioButtonGroup.make, {
        children: options.map((param, index) => {
          let value = param[0];
          return JsxRuntime.jsx(RadioButtonNew.make, {
            label: param[1],
            name: "property-sort-order",
            id: `sort-order-` + index.toString(),
            onChange: param => refetch(undefined, undefined, undefined, params => {
              let newrecord = {...params};
              newrecord.sortOrder = value;
              return newrecord;
            }),
            checked: params.sortOrder === value,
            additionalLabelStyle: "whitespace-nowrap"
          }, index.toString());
        })
      })
    ]
  });
}

let SortOrder = {
  options: options,
  labelFor: labelFor,
  make: PropertiesPageRelayFilters$SortOrder
};

function PropertiesPageRelayFilters$AreasItem$AreasInput(props) {
  let refetch = props.refetch;
  let setSelectedAreas = props.setSelectedAreas;
  return JsxRuntime.jsx(PropertiesFiltersAreasAutocomplete.make, {
    value: props.selectedAreas,
    onChange: v => {
      setSelectedAreas(param => v);
      refetch(undefined, undefined, undefined, params => {
        let newrecord = {...params};
        newrecord.areaIds = v.length !== 0 ? v.map(d => d.id) : undefined;
        return newrecord;
      });
    }
  });
}

let AreasInput = {
  make: PropertiesPageRelayFilters$AreasItem$AreasInput
};

function PropertiesPageRelayFilters$AreasItem$HelpText(props) {
  return JsxRuntime.jsx("span", {
    children: props.children,
    className: "italic text-zinc-500 leading-normal"
  });
}

let HelpText = {
  make: PropertiesPageRelayFilters$AreasItem$HelpText
};

function PropertiesPageRelayFilters$AreasItem(props) {
  let defaultAreas = props.defaultAreas;
  let selectedAreaIds = props.selectedAreaIds;
  let tmp;
  if (selectedAreaIds.length !== 0 || defaultAreas === undefined || defaultAreas.length === 0) {
    tmp = null;
  } else {
    let __x = defaultAreas.map(x => x.label);
    tmp = JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(PropertiesPageRelayFilters$AreasItem$HelpText, {
          children: "By default we are searching in your chapter's predetermined areas:"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(PropertiesPageRelayFilters$AreasItem$HelpText, {
            children: Utils.$$Array.pseudoJoin(", ", " and ", __x).join("")
          })
        })
      ],
      className: "mb-2"
    });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Areas"
      }),
      tmp,
      JsxRuntime.jsx(PropertiesPageRelayFilters$AreasItem$AreasInput, {
        selectedAreas: selectedAreaIds.length !== 0 ? props.selectedAreas : [],
        setSelectedAreas: props.setSelectedAreas,
        refetch: props.refetch
      })
    ],
    className: "min-w-[300px]"
  });
}

let AreasItem = {
  AreasInput: AreasInput,
  HelpText: HelpText,
  make: PropertiesPageRelayFilters$AreasItem
};

function PropertiesPageRelayFilters$TANStatuses(props) {
  let refetch = props.refetch;
  let isDesktop = MediaQuery.isDesktop();
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let checkboxes = props.rentalMode ? [
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.active = !params.active;
          return newrecord;
        }),
        checked: params.active,
        label: "Active",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.withdrawnOrExpired = !params.withdrawnOrExpired;
          return newrecord;
        }),
        checked: params.withdrawnOrExpired,
        label: "Withdrawn / Expired",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.soldOrRented = !params.soldOrRented;
          return newrecord;
        }),
        checked: params.soldOrRented,
        label: "Rented",
        mobileStyles: true
      })
    ] : [
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.active = !params.active;
          return newrecord;
        }),
        checked: params.active,
        label: "Active",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.withdrawnOrExpired = !params.withdrawnOrExpired;
          return newrecord;
        }),
        checked: params.withdrawnOrExpired,
        label: "Withdrawn / Expired",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.soldOrRented = !params.soldOrRented;
          return newrecord;
        }),
        checked: params.soldOrRented,
        label: "Sold",
        mobileStyles: true
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.underContract = !params.underContract;
          return newrecord;
        }),
        checked: params.underContract,
        label: "Under Contract",
        mobileStyles: true
      })
    ];
  return JsxRuntime.jsxs(ViewStack.make, {
    space: "sm",
    width: isDesktop ? ({
        NAME: "px",
        VAL: "w320"
      }) : undefined,
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "TAN Status"
      }),
      isDesktop ? JsxRuntime.jsx("div", {
          children: checkboxes.map((e, i) => JsxRuntime.jsx("div", {
            children: e,
            className: "grid-span-1"
          }, i.toString())),
          className: "grid grid-cols-2 gap-2"
        }) : JsxRuntime.jsx(TogglesGroup.make, {
          inline: false,
          children: checkboxes.map((e, i) => React.cloneElement(e, {
            key: i.toString()
          }))
        })
    ]
  });
}

let TANStatuses = {
  make: PropertiesPageRelayFilters$TANStatuses
};

function PropertiesPageRelayFilters$Keywords(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Keywords or Address"
      }),
      JsxRuntime.jsx(FormV5.SearchField.make, {
        value: Stdlib_Option.getOr(match[0].keywords, []),
        onChange: value => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.keywords = value;
          return newrecord;
        }),
        placeholderText: "1255 Main Street, waterfront, new construction"
      })
    ]
  });
}

let Keywords = {
  make: PropertiesPageRelayFilters$Keywords
};

function PropertiesPageRelayFilters$MinPrice(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let max = params.maxPrice;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Lower Price"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: e => {
          let value = Stdlib_Option.map(e, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.minPrice = value;
            return newrecord;
          });
        },
        options: max !== undefined ? priceOptions.filter(x => x.value < max) : priceOptions,
        value: Stdlib_Option.map(params.minPrice, p => ({
          value: p,
          label: PropertyFilterOptions.Option.makeLabel(p, priceOptions)
        }))
      })
    ],
    className: "flex-1 min-w-48"
  });
}

let MinPrice = {
  make: PropertiesPageRelayFilters$MinPrice
};

function PropertiesPageRelayFilters$MaxPrice(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let rentalMode = params.rentalMode;
  let priceOptions = rentalMode ? PropertyFilterOptions.PriceFilters.rentalOptions : PropertyFilterOptions.PriceFilters.forSaleOptions;
  let min = params.minPrice;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Upper Price"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: e => {
          let value = Stdlib_Option.map(e, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.maxPrice = value;
            return newrecord;
          });
        },
        options: min !== undefined ? priceOptions.filter(x => x.value > min) : priceOptions,
        value: Stdlib_Option.map(params.maxPrice, p => ({
          value: p,
          label: PropertyFilterOptions.Option.makeLabel(p, priceOptions)
        }))
      })
    ],
    className: "flex-1 min-w-48"
  });
}

let MaxPrice = {
  make: PropertiesPageRelayFilters$MaxPrice
};

function PropertiesPageRelayFilters$MinBeds(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let bedsOptions = PropertyFilterOptions.BedsFilters.options;
  let max = params.maxBeds;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Min beds"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: v => {
          let value = Stdlib_Option.map(v, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.minBeds = value;
            return newrecord;
          });
        },
        options: max !== undefined ? bedsOptions.filter(x => x.value < max) : bedsOptions,
        value: Stdlib_Option.map(params.minBeds, n => ({
          value: n,
          label: n.toString()
        }))
      })
    ],
    className: "min-w-48"
  });
}

let MinBeds = {
  make: PropertiesPageRelayFilters$MinBeds
};

function PropertiesPageRelayFilters$MaxBeds(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let bedsOptions = PropertyFilterOptions.BedsFilters.options;
  let min = params.minBeds;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "Max beds"
      }),
      JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
        getOptionLabel: PropertyFilterOptions.Option.getOptionLabel,
        getOptionValue: PropertyFilterOptions.Option.getOptionValue,
        isClearable: true,
        onChange: v => {
          let value = Stdlib_Option.map(v, e => e.value);
          refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.maxBeds = value;
            return newrecord;
          });
        },
        options: min !== undefined ? bedsOptions.filter(x => x.value > min) : bedsOptions,
        value: Stdlib_Option.map(params.maxBeds, n => ({
          value: n,
          label: n.toString()
        }))
      })
    ],
    className: "min-w-48"
  });
}

let MaxBeds = {
  make: PropertiesPageRelayFilters$MaxBeds
};

function PropertiesPageRelayFilters$MlsStatus(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let isDesktop = MediaQuery.isDesktop();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(Form__Label.make, {
        labelText: "MLS Status"
      }),
      JsxRuntime.jsx(Form__Checkbox.make, {
        onChange: param => refetch(undefined, undefined, undefined, params => {
          let newrecord = {...params};
          newrecord.offMlsOnly = !Stdlib_Option.getOr(params.offMlsOnly, false);
          return newrecord;
        }),
        checked: Stdlib_Option.getOr(match[0].offMlsOnly, false),
        label: `Only properties not "Active" on the MLS`,
        mobileStyles: !isDesktop
      })
    ]
  });
}

let MlsStatus = {
  make: PropertiesPageRelayFilters$MlsStatus
};

function PropertiesPageRelayFilters$IncludeNewDevelopments(props) {
  let refetch = props.refetch;
  let match = PropertiesPageRelayQueryParams.use();
  let params = match[0];
  let isDesktop = MediaQuery.isDesktop();
  let developmentsEnabled = FeaturesV3.useIsDevelopmentsEnabled() === true;
  if (params.rentalMode || !developmentsEnabled) {
    return null;
  } else {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Form__Label.make, {
          labelText: "Development Projects"
        }),
        JsxRuntime.jsx(Form__Checkbox.make, {
          onChange: param => refetch(undefined, undefined, undefined, params => {
            let newrecord = {...params};
            newrecord.includeNewDevelopments = !params.includeNewDevelopments;
            return newrecord;
          }),
          checked: params.includeNewDevelopments,
          label: "Include sample units",
          mobileStyles: !isDesktop
        })
      ]
    });
  }
}

let IncludeNewDevelopments = {
  make: PropertiesPageRelayFilters$IncludeNewDevelopments
};

let QueryParams;

let Checkbox;

let RadioButtonGroup;

let RadioButton;

let TogglesGroup$1;

let Grid;

let Cell;

let MenuItem;

exports.QueryParams = QueryParams;
exports.Checkbox = Checkbox;
exports.RadioButtonGroup = RadioButtonGroup;
exports.RadioButton = RadioButton;
exports.TogglesGroup = TogglesGroup$1;
exports.Grid = Grid;
exports.Cell = Cell;
exports.MenuItem = MenuItem;
exports.PropertyTypes = PropertyTypes;
exports.SortOrder = SortOrder;
exports.AreasItem = AreasItem;
exports.TANStatuses = TANStatuses;
exports.Keywords = Keywords;
exports.MinPrice = MinPrice;
exports.MaxPrice = MaxPrice;
exports.MinBeds = MinBeds;
exports.MaxBeds = MaxBeds;
exports.MlsStatus = MlsStatus;
exports.IncludeNewDevelopments = IncludeNewDevelopments;
/* Utils Not a pure module */
